export const AUTO_TAG_RCS = 'rcs';
export const AUTO_TAG_COUPON = 'coupon';

export const ALLOWED_MANUAL_TAGS = [
	'welcome-series',
	'abandonment',
	'post-purchase',
	'thank-you',
	'winback',
];

export const FILTER_TAG_LABELS = {
	[AUTO_TAG_RCS]: 'RCS',
	[AUTO_TAG_COUPON]: 'Coupons',
	'welcome-series': 'Welcome Series',
	abandonment: 'Abandonment',
	'post-purchase': 'Post-Purchase',
	'thank-you': 'Thank You',
	winback: 'Winback',
};

export const FILTER_TAG_ORDER = [
	AUTO_TAG_RCS,
	AUTO_TAG_COUPON,
	...ALLOWED_MANUAL_TAGS,
];

// Small, explicit allowlist mapping an Inspiration category slug to the
// manual tag whose messages should be pulled in alongside it. Not every
// Inspiration slug has a matching tag yet, so this is deliberately sparse.
// It is additive only: it supplements the existing hand-picked results for
// that slug, it never replaces them.
export const INSPIRATION_SLUG_TAGS = {
	welcome: 'welcome-series',
	cart: 'abandonment',
	browse: 'abandonment',
};

export const isRcsMessage = (message) =>
	message?.type === 'chat' ||
	(Array.isArray(message?.botMessages) && message.botMessages.length > 0);

export const isCouponMessage = (message) => /\bcode\b/i.test(message?.body || '');

export const getEffectiveTags = (message) => {
	const tags = new Set(Array.isArray(message?.tags) ? message.tags : []);
	if (isRcsMessage(message)) tags.add(AUTO_TAG_RCS);
	if (isCouponMessage(message)) tags.add(AUTO_TAG_COUPON);
	return Array.from(tags);
};

export const withEffectiveTags = (messages) =>
	(Array.isArray(messages) ? messages : []).map((m) => ({
		...m,
		tags: getEffectiveTags(m),
	}));
